
export default () => ({
  loggedIn: false,
  token: '',
  tokenExpires: '',
  user: null,
  userId: null,
  redirectUrl: '/account',
  ipAddress: ''
})
